const limaDateTime = new Intl.DateTimeFormat('es-PE', {
  timeZone: 'America/Lima',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

const displayDate = new Intl.DateTimeFormat('es-PE', {
  timeZone: 'UTC',
  day: 'numeric',
  month: 'long',
});

const fixedNationalHolidays = new Set([
  '01-01', '05-01', '06-07', '06-29', '07-23', '07-28', '07-29',
  '08-06', '08-30', '10-08', '11-01', '12-08', '12-09', '12-25',
]);
const holyWeekDaysByYear = new Map();

// UTC fields represent a Lima calendar date, never the shopper's local date.
function addCalendarDays(date, days) {
  const result = new Date(date);
  result.setUTCDate(result.getUTCDate() + days);
  return result;
}

function monthDay(date) {
  return `${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

// Gregorian computus (Meeus/Jones/Butcher), valid for future Gregorian years.
export function getEasterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const monthAndDay = h + l - 7 * m + 114;
  const month = Math.floor(monthAndDay / 31);
  const day = (monthAndDay % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day));
}

function isNationalHoliday(date) {
  if (fixedNationalHolidays.has(monthDay(date))) return true;

  const year = date.getUTCFullYear();
  if (!holyWeekDaysByYear.has(year)) {
    const easter = getEasterSunday(year);
    holyWeekDaysByYear.set(year, new Set([
      monthDay(addCalendarDays(easter, -3)),
      monthDay(addCalendarDays(easter, -2)),
    ]));
  }
  return holyWeekDaysByYear.get(year).has(monthDay(date));
}

export function isValidDeliveryDay(date) {
  const dayOfWeek = date.getUTCDay();
  return dayOfWeek !== 0 && dayOfWeek !== 6 && !isNationalHoliday(date);
}

export function addDeliveryDays(startDate, numberOfDays) {
  if (!Number.isInteger(numberOfDays) || numberOfDays < 0) {
    throw new RangeError('numberOfDays must be a non-negative integer');
  }

  let date = new Date(startDate);
  let validDays = 0;
  while (validDays < numberOfDays) {
    date = addCalendarDays(date, 1);
    if (isValidDeliveryDay(date)) validDays += 1;
  }
  return date;
}

export function getDeliveryEstimates(now = new Date()) {
  const parts = Object.fromEntries(
    limaDateTime.formatToParts(now)
      .filter(({ type }) => type !== 'literal')
      .map(({ type, value }) => [type, Number(value)]),
  );
  const today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  const limaStart = addDeliveryDays(today, 1);
  const limaEnd = addDeliveryDays(today, 2);
  const provinceStart = addDeliveryDays(today, 3);
  const provinceEnd = addDeliveryDays(today, 4);

  function formatRange(start, end) {
    return start.getUTCMonth() === end.getUTCMonth()
      ? `${start.getUTCDate()} y ${displayDate.format(end)}`
      : `${displayDate.format(start)} y ${displayDate.format(end)}`;
  }

  return {
    lima: `Recíbelo entre el ${formatRange(limaStart, limaEnd)} aprox.`,
    provinces: `Recíbelo entre el ${formatRange(provinceStart, provinceEnd)} aprox.`,
  };
}

function updateDeliveryEstimates() {
  const estimates = getDeliveryEstimates();
  document.querySelectorAll('[data-imperia-delivery-estimate]').forEach((element) => {
    element.querySelector('[data-delivery-lima]').textContent = estimates.lima;
    element.querySelector('[data-delivery-provinces]').textContent = estimates.provinces;
  });
}

function scheduleNextUpdate() {
  const delay = 60000 - (Date.now() % 60000) + 50;
  window.setTimeout(() => {
    updateDeliveryEstimates();
    scheduleNextUpdate();
  }, delay);
}

if (typeof document !== 'undefined') {
  updateDeliveryEstimates();
  scheduleNextUpdate();
  window.addEventListener('pageshow', updateDeliveryEstimates);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateDeliveryEstimates();
  });
}
